import React from "react";
import moment from "moment";
import napformat from "../../../config/napformat";
import CustomTable from "src/components/CustomTable";

const TableDiario = (props) => {
  const { data, loading } = props;

  const columns = [
    {
      title: "VOUCHER",
      dataIndex: "n_voucher",
      key: "n_voucher",
      align: "center",
      width: 100,
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "FECHA",
      dataIndex: "operation_date",
      key: "operation_date",
      align: "center",
      width: 100,
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text ? moment(text).format("DD/MM/YYYY") : "",
        };
      },
    },
    {
      title: "DESCRIPCIÓN",
      dataIndex: "description",
      key: "description",
      align: "center",
      width: 500,
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "ORIGEN",
      dataIndex: "origin",
      key: "origin",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "TIPO",
      dataIndex: "t_doc",
      key: "t_doc",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "RUC",
      dataIndex: "customer",
      key: "customer",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "SERIE",
      dataIndex: "serie",
      key: "serie",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "NÚMERO",
      dataIndex: "correlative",
      key: "correlative",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "CUENTA",
      dataIndex: "account_plan",
      key: "account_plan",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text,
        };
      },
    },
    {
      title: "DEBE",
      dataIndex: "debit",
      key: "debit",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text ? napformat(text) : "",
        };
      },
    },
    {
      title: "HABER",
      dataIndex: "asset",
      key: "asset",
      align: "center",
      render: (text, record) => {
        return {
          props: {
            style: { background: record.n_voucher ? "" : "#01579b30" },
          },
          children: text ? napformat(text) : "",
        };
      },
    },
  ];

  return (
    <CustomTable
      columns={columns}
      data={data}
      loading={loading}
      pagination={{ pageSize: 100, position: "both" }}
    />
  );
};

export default TableDiario;
